import React, { useState } from "react";
import axios from "axios";
import { Send, CheckCircle } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TASK_TYPES = [
  ["general", "Поручение"], ["property_check", "Проверка объекта"], ["secret_shopper", "Тайный покупатель"],
  ["grave_care", "Мемориальный сервис"], ["delivery", "Доставка / курьер"], ["b2b", "Задание от организации"], ["other", "Другое"],
];

// D8: лид-форма «Оставить заявку» (honeypot + согласие 152-ФЗ со ссылкой на /legal/privacy)
export const LeadForm = ({ page = "/" }) => {
  const [form, setForm] = useState({ name: "", contact: "", task_type: "general", description: "", consent: false, website: "" });
  const [state, setState] = useState({ sending: false, done: false, error: "" });
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.type === "checkbox" ? e.target.checked : e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (state.sending) return;
    setState({ sending: true, done: false, error: "" });
    try {
      await axios.post(`${API}/public/leads`, { ...form, page });
      setState({ sending: false, done: true, error: "" });
    } catch (err) {
      setState({ sending: false, done: false, error: err.response?.data?.detail || "Не удалось отправить заявку" });
    }
  };

  return (
    <section className="w-full px-4 sm:px-6 py-12" style={{ background: "#F0FDFA" }} data-testid="lead-form-section">
      <div className="max-w-3xl mx-auto">
        <h2 className="text-2xl font-bold mb-2" style={{ fontFamily: "Manrope,sans-serif", color: "var(--rv-navy)" }}>Оставить заявку</h2>
        <p className="text-sm mb-6" style={{ color: "var(--rv-text-secondary)" }}>Опишите задачу в двух словах — мы свяжемся и поможем разместить задание.</p>
        {state.done ? (
          <div className="flex items-center gap-2 p-4 rounded-lg" style={{ background: "#fff", border: "1px solid #5EEAD4", color: "#134E4A" }} data-testid="lead-form-success">
            <CheckCircle size={18} /> Заявка принята. Мы свяжемся с вами в ближайшее время.
          </div>
        ) : (
          <form onSubmit={submit} className="grid grid-cols-1 sm:grid-cols-2 gap-3" data-testid="lead-form">
            <input className="w-full rounded-md border border-gray-300 bg-white px-3 py-2 text-sm" placeholder="Ваше имя" value={form.name} onChange={set("name")} required data-testid="lead-name-input" />
            <input className="w-full rounded-md border border-gray-300 bg-white px-3 py-2 text-sm" placeholder="Email или телефон" value={form.contact} onChange={set("contact")} required data-testid="lead-contact-input" />
            <select className="w-full rounded-md border border-gray-300 bg-white px-3 py-2 text-sm sm:col-span-2" value={form.task_type} onChange={set("task_type")} data-testid="lead-type-select">
              {TASK_TYPES.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
            </select>
            <div className="sm:col-span-2">
              <textarea className="w-full rounded-md border border-gray-300 bg-white px-3 py-2 text-sm" rows={3} maxLength={500}
                placeholder="Пара слов о задаче (необязательно). Например: снять 20 товаров в магазине на ул. Красной, отчёт до пятницы"
                value={form.description} onChange={set("description")} data-testid="lead-description-input" />
              <p className="text-xs text-right mt-0.5" style={{ color: "var(--rv-text-muted)" }} data-testid="lead-description-counter">{form.description.length}/500</p>
            </div>
            <input type="text" name="website" value={form.website} onChange={set("website")} tabIndex={-1} autoComplete="off" aria-hidden="true"
              style={{ position: "absolute", left: "-9999px", width: 1, height: 1, opacity: 0 }} />
            <label className="sm:col-span-2 flex items-start gap-2 text-xs" style={{ color: "var(--rv-text-secondary)" }}>
              <input type="checkbox" checked={form.consent} onChange={set("consent")} required className="mt-0.5" data-testid="lead-consent-checkbox" />
              <span>Я даю согласие на обработку персональных данных (имя, контакт) для связи по заявке в соответствии с <a href="/legal/privacy" target="_blank" rel="noopener noreferrer" style={{ color: "var(--rv-teal)" }}>Политикой конфиденциальности</a>.</span>
            </label>
            {state.error && <p className="sm:col-span-2 text-sm text-red-600" data-testid="lead-form-error">{state.error}</p>}
            <button type="submit" disabled={state.sending || !form.consent} className="reversia-btn reversia-btn-md sm:col-span-2 flex items-center justify-center gap-2 disabled:opacity-60"
              style={{ background: "var(--rv-teal)", color: "#fff" }} data-testid="lead-submit-btn">
              <Send size={14} /> {state.sending ? "Отправляем..." : "Отправить заявку"}
            </button>
          </form>
        )}
      </div>
    </section>
  );
};
